export default "__VITE_ASSET__BeznZClS__"